import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PageWebContent from '@/views/platforms/web/PageWebContent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PageContentDefault',
  setup(__props) {

let PageContent:any = null;









PageContent = PageWebContent;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageContent), null, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})